// extracted by mini-css-extract-plugin
module.exports = {"validnameCls":"user_validnameCls__3rHJF","field":"user_field__SRLyE","btn":"user_btn__2EShX","row-d":"user_row-d__qJcRn"};